<template>
  <validation-provider
    v-slot="{ errors }"
    :name="$attrs.name"
    :rules="iRules"
    :vid="vid"
  >
    <v-switch
      v-bind="$attrs"
      :input-value="iValue"
      :value="$attrs.trueValue"
      :error-messages="errors"
      :error="validation && !!errors.length"
      :hide-details="!validation || !errors.length"
      :label="displayLabel"
      :dark="fixedLabelDark"
      class="mt-0 pt-0"
      inset
      v-on="$listeners"
    />
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { useValidation } from '@/compositions/validation'

export default {
  name: 'FieldSwitch',
  components: {
    ValidationProvider
  },
  props: {
    label: {
      type: String,
      default: null
    },
    fixedLabelDark: {
      type: Boolean,
      default: false
    },
    rules: {
      type: [String, Object],
      default: () => ({})
    },
    validation: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: null
    },
    value: {
      type: [Boolean, String, Number, Array],
      default: null
    }
  },
  setup (props) {
    const { iRules, displayLabel } = useValidation(props)

    return { iRules, displayLabel }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
